export default "__VITE_ASSET__BB$gnxcG__";